export const GET_ALL_MAILS = 'GET_ALL_MAILS';
export const SEND_MAIL = 'SEND_MAIL';
export const GET_EMAIL_BY_ID = 'GET_EMAIL_BY_ID';
